export default function IntegrationsWelcomeComponent() {
  const cardsMap = [
    {
      name: "Github Integration",
      link: "github-integration",
      icon: (
        <svg
          width="27"
          height="27"
          viewBox="0 0 27 27"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.5 0C6.04125 0 0 6.19406 0 13.8415C0 19.9663 3.86438 25.1396 9.23063 26.9736C9.90563 27.0947 10.1587 26.6794 10.1587 26.3161C10.1587 25.9874 10.1419 24.8973 10.1419 23.7381C6.75 24.3783 5.8725 22.8903 5.6025 22.1117C5.45062 21.7138 4.7925 20.4854 4.21875 20.1566C3.74625 19.8971 3.07125 19.2569 4.20188 19.2396C5.265 19.2223 6.02438 20.2431 6.2775 20.6584C7.4925 22.7519 9.43312 22.1636 10.2094 21.8003C10.3275 20.9006 10.6819 20.295 11.07 19.949C8.06625 19.603 4.9275 18.4092 4.9275 13.1148C4.9275 11.6095 5.45063 10.3638 6.31125 9.3949C6.17625 9.04886 5.70375 7.63011 6.44625 5.72691C6.44625 5.72691 7.57688 5.36357 10.1587 7.14566C11.2388 6.83422 12.3862 6.67851 13.5338 6.67851C14.6813 6.67851 15.8287 6.83422 16.9088 7.14566C19.4906 5.34627 20.6213 5.72691 20.6213 5.72691C21.3638 7.63011 20.8913 9.04886 20.7563 9.3949C21.6169 10.3638 22.14 11.5922 22.14 13.1148C22.14 18.4265 18.9844 19.603 15.9806 19.949C16.47 20.3816 16.8919 21.212 16.8919 22.5097C16.8919 24.361 16.875 25.8489 16.875 26.3161C16.875 26.6794 17.1281 27.112 17.8031 26.9736C20.4832 26.046 22.8119 24.28 24.4617 21.9242C26.1115 19.5685 26.9993 16.7416 27 13.8415C27 6.19406 20.9587 0 13.5 0Z"
            fill="black"
          />
        </svg>
      ),
    },
    {
      name: "Asana Integration",
      link: "asana-integration",
      icon: (
        <svg
          width="29"
          height="27"
          viewBox="0 0 29 27"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M22.027 14.294C18.6461 14.294 15.9051 17.1383 15.9051 20.6472C15.9051 24.1557 18.6461 27 22.027 27C25.4081 27 28.1489 24.1557 28.1489 20.6472C28.1489 17.1383 25.4081 14.294 22.027 14.294ZM6.12189 14.2946C2.74089 14.2946 0 17.1383 0 20.6472C0 24.1557 2.74089 27 6.12189 27C9.50304 27 12.2441 24.1557 12.2441 20.6472C12.2441 17.1383 9.50304 14.2946 6.12189 14.2946ZM20.1963 6.35271C20.1963 9.8616 17.4555 12.7062 14.0745 12.7062C10.6933 12.7062 7.95261 9.8616 7.95261 6.35271C7.95261 2.84459 10.6933 0 14.0745 0C17.4555 0 20.1963 2.84459 20.1963 6.35271Z"
            fill="#F06A6A"
          />
        </svg>
      ),
    },
    {
      name: "Jira Integration",
      link: "jira-integration",
      icon: (
        <svg
          width="28"
          height="27"
          viewBox="0 0 28 27"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M25.9397 12.8389L15.0468 2.67292L13.9909 1.6875L5.79107 9.34006L2.042 12.8389C1.65112 13.2042 1.65112 13.7958 2.042 14.1611L9.53347 21.1526L13.9909 25.3125L22.1907 17.6599L22.3177 17.5415L25.9397 14.1611C26.3307 13.7958 26.3307 13.2042 25.9397 12.8389ZM13.9909 16.9926L10.2485 13.5L13.9909 10.0074L17.7333 13.5L13.9909 16.9926Z"
            fill="#2684FF"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M13.9908 10.0074C11.5407 7.72044 11.5287 4.01626 13.9642 1.71558L5.77435 9.35568L10.2318 13.5156L13.9908 10.0074Z"
            fill="url(#paint0_linear_123_595)"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M17.7433 13.4907L13.9909 16.9927C15.1736 18.0957 15.8381 19.5922 15.8381 21.1526C15.8381 22.7131 15.1736 24.2095 13.9909 25.3126L22.2008 17.6507L17.7433 13.4907Z"
            fill="url(#paint1_linear_123_595)"
          />
          <defs>
            <linearGradient
              id="paint0_linear_123_595"
              x1="13.3226"
              y1="6.47426"
              x2="7.15298"
              y2="9.26598"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.18" stop-color="#0052CC" />
              <stop offset="1" stop-color="#2684FF" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_123_595"
              x1="14.7059"
              y1="20.4853"
              x2="20.8651"
              y2="17.7131"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.18" stop-color="#0052CC" />
              <stop offset="1" stop-color="#2684FF" />
            </linearGradient>
          </defs>
        </svg>
      ),
    },
    {
      name: "Trello Integration",
      link: "trello-integration",
      icon: (
        <svg
          width="27"
          height="27"
          viewBox="0 0 27 27"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M23.64 0H3.37714C1.512 0 0 1.51104 0 3.375V23.625C0 25.489 1.512 27 3.37714 27H23.64C25.4985 26.9905 27 25.4823 27 23.625V3.375C27 1.5177 25.4985 0.0094275 23.64 0ZM5.625 3.375H10.125C11.3677 3.375 12.375 4.38236 12.375 5.625V21.375C12.375 22.6177 11.3677 23.625 10.125 23.625H5.625C4.38236 23.625 3.375 22.6177 3.375 21.375V5.625C3.375 4.38236 4.38236 3.375 5.625 3.375ZM21.375 3.375H16.875C15.6323 3.375 14.625 4.38236 14.625 5.625V13.5C14.625 14.7427 15.6323 15.75 16.875 15.75H21.375C22.6177 15.75 23.625 14.7427 23.625 13.5V5.625C23.625 4.38236 22.6177 3.375 21.375 3.375Z"
            fill="url(#paint0_linear_123_580)"
          />
          <defs>
            <linearGradient
              id="paint0_linear_123_580"
              x1="13.5086"
              y1="27"
              x2="13.5086"
              y2="0"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#0052CC" />
              <stop offset="0.51698" stop-color="#217EF8" />
              <stop offset="1" stop-color="#2684FF" />
            </linearGradient>
          </defs>
        </svg>
      ),
    },
  ];

  return (
    <div className="flex flex-col items-center justify-center bg-white pb-16 !mt-0">
      <div className="max-w-3xl w-full text-center">
        <h1 className="text-[3em] mb-4 font-raleway-700 font-bold">
          Welcome to <span className="text-[#27AE60]">Flicktest Integration</span>
        </h1>
        <p className="text-[#282828] mb-8 font-poppins font-normal ">
          Flicktest is a comprehensive tool that simplifies test management for
          QA, Development, Product, and DevOps teams. It easily connects with
          popular software development and project management tools, making the
          entire process more efficient
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 font-poppins">
          {cardsMap.map((item, index) => (
            <a href={`/docs/integrations/${item.link}`}>
              <button className="flex items-center justify-between group border-2 border-gray-200 rounded-lg p-4 shadow-sm hover:border-[#89AAFF] transition-colors font-medium text-[#1F1F1F] w-full">
                <div className="flex items-center justify-between">
                  {item.icon}
                  <span className="ml-2 font-semibold text-sm ">
                    {item.name}
                  </span>
                </div>
                <svg
                  width="13"
                  height="13"
                  viewBox="0 0 13 13"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    className="group-hover:stroke-[#316BFF] stroke-[#898187]"
                    d="M5.88889 8.94444L8.33333 6.5M8.33333 6.5L5.88889 4.05556M8.33333 6.5H1M1.92617 9.55556C2.91282 11.0296 4.59308 12 6.5 12C9.53759 12 12 9.53759 12 6.5C12 3.46244 9.53759 1 6.5 1C4.59308 1 2.91282 1.97046 1.92617 3.44444"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}
